export default __webpack_public_path__ + "static/Entenda0102-4e417fe4b508b9f1b358be317c91842d.jpg";